export default "__VITE_ASSET__Dn2WLXAB__"